const keeperAttrWeights = {
  DIV: { gkDiving: 1 },
  HAN: { gkHandling: 1 },
  KIC: { gkKicking: 1 },
  REF: { gkReflexes: 1 },
  SPD: { acceleration: 0.45, sprintSpeed: 0.55 },
  POS: { gkPositioning: 1 },
};

const playerAttrWeights = {
  PAC: { acceleration: 0.45, sprintSpeed: 0.55 },
  SHO: {
    positioning: 0.05,
    finishing: 0.45,
    shotPower: 0.2,
    longShots: 0.2,
    volleys: 0.05,
    penalties: 0.05,
  },
  PAS: {
    vision: 0.2,
    crossing: 0.2,
    freeKickAccuracy: 0.05,
    shortPassing: 0.35,
    longPassing: 0.15,
    curve: 0.05,
  },
  DRI: {
    agility: 0.1,
    balance: 0.05,
    reactions: 0.05,
    ballControl: 0.3,
    dribbling: 0.45,
    composure: 0.05,
  },
  DEF: {
    interceptions: 0.2,
    headingAccuracy: 0.1,
    defensiveAwareness: 0.3,
    standingTackles: 0.3,
    slidingTackles: 0.1,
  },
  PHY: {
    jumping: 0.05,
    stamina: 0.25,
    strength: 0.5,
    aggression: 0.2,
  },
};

const chemstyleStatBonus = {
  "257": {
    "3": {
      curve: 8,
      jumping: 8,
      vision: 8,
      strength: 12,
      shortPassing: 12,
      longPassing: 4,
      aggression: 4,
      freeKickAccuracy: 4,
    },
    "2": {
      strength: 8,
      longPassing: 2,
      jumping: 4,
      curve: 4,
      freeKickAccuracy: 2,
      vision: 4,
      shortPassing: 8,
      aggression: 2,
    },
    "1": {
      shortPassing: 3,
      aggression: 1,
      strength: 3,
      vision: 2,
      jumping: 2,
      longPassing: 1,
      freeKickAccuracy: 1,
      curve: 2,
    },
  },
  "266": {
    "3": {
      sprintSpeed: 8,
      positioning: 4,
      penalties: 8,
      volleys: 12,
      acceleration: 8,
      shotPower: 4,
      finishing: 8,
    },
    "2": {
      volleys: 8,
      penalties: 4,
      acceleration: 4,
      sprintSpeed: 4,
      positioning: 2,
      finishing: 4,
      shotPower: 2,
    },
    "1": {
      positioning: 1,
      shotPower: 1,
      volleys: 3,
      sprintSpeed: 2,
      finishing: 2,
      penalties: 2,
      acceleration: 2,
    },
  },
  "252": {
    "3": {
      agility: 8,
      finishing: 12,
      dribbling: 12,
      penalties: 4,
      positioning: 8,
      volleys: 8,
      balance: 4,
      shotPower: 4,
    },
    "2": {
      volleys: 4,
      penalties: 2,
      dribbling: 8,
      shotPower: 2,
      finishing: 8,
      positioning: 4,
      balance: 2,
      agility: 4,
    },
    "1": {
      positioning: 2,
      dribbling: 3,
      penalties: 1,
      agility: 2,
      finishing: 3,
      volleys: 2,
      shotPower: 1,
      balance: 1,
    },
  },
  "255": {
    "3": {
      acceleration: 4,
      shotPower: 8,
      strength: 4,
      longShots: 8,
      positioning: 4,
      aggression: 8,
      sprintSpeed: 4,
      finishing: 4,
      penalties: 4,
      jumping: 8,
    },
    "2": {
      penalties: 2,
      finishing: 2,
      aggression: 4,
      longShots: 4,
      shotPower: 2,
      strength: 2,
      sprintSpeed: 2,
      acceleration: 2,
      jumping: 4,
      positioning: 2,
    },
    "1": {
      shotPower: 2,
      finishing: 1,
      longShots: 2,
      aggression: 2,
      acceleration: 1,
      strength: 1,
      positioning: 1,
      penalties: 1,
      jumping: 2,
      sprintSpeed: 1,
    },
  },
  "256": {
    "3": {
      longPassing: 12,
      freeKickAccuracy: 4,
      reactions: 4,
      vision: 8,
      agility: 12,
      crossing: 8,
      curve: 4,
      dribbling: 8,
    },
    "2": {
      reactions: 2,
      agility: 8,
      vision: 4,
      crossing: 4,
      curve: 2,
      freeKickAccuracy: 2,
      dribbling: 4,
      longPassing: 8,
    },
    "1": {
      longPassing: 3,
      dribbling: 2,
      crossing: 2,
      curve: 1,
      reactions: 1,
      agility: 3,
      vision: 2,
      freeKickAccuracy: 1,
    },
  },
  "253": {
    "3": {
      penalties: 4,
      finishing: 8,
      shortPassing: 12,
      positioning: 8,
      vision: 8,
      longShots: 4,
      curve: 4,
      shotPower: 12,
    },
    "2": {
      finishing: 4,
      longShots: 2,
      shortPassing: 8,
      shotPower: 8,
      curve: 2,
      positioning: 4,
      penalties: 2,
      vision: 4,
    },
    "1": {
      penalties: 1,
      shortPassing: 3,
      shotPower: 3,
      finishing: 2,
      vision: 2,
      longShots: 1,
      curve: 1,
      positioning: 2,
    },
  },
  "259": {
    "3": {
      shortPassing: 4,
      volleys: 4,
      longPassing: 8,
      reactions: 8,
      vision: 4,
      dribbling: 8,
      shotPower: 8,
      freeKickAccuracy: 8,
      longShots: 8,
    },
    "2": {
      volleys: 2,
      longPassing: 4,
      reactions: 4,
      shortPassing: 2,
      vision: 2,
      freeKickAccuracy: 4,
      longShots: 4,
      shotPower: 4,
      dribbling: 4,
    },
    "1": {
      shortPassing: 1,
      volleys: 1,
      dribbling: 2,
      freeKickAccuracy: 2,
      shotPower: 2,
      vision: 1,
      reactions: 2,
      longShots: 2,
      longPassing: 2,
    },
  },
  "250": {
    "3": {
      positioning: 4,
      ballControl: 4,
      slidingTackles: 4,
      shortPassing: 4,
      sprintSpeed: 4,
      curve: 4,
      defensiveAwareness: 4,
      shotPower: 4,
      vision: 4,
      penalties: 4,
      agility: 4,
      longPassing: 4,
      volleys: 4,
      strength: 4,
      standingTackles: 4,
      dribbling: 4,
    },
    "2": {
      penalties: 2,
      agility: 2,
      slidingTackles: 2,
      shotPower: 2,
      longPassing: 2,
      dribbling: 2,
      vision: 2,
      volleys: 2,
      curve: 2,
      sprintSpeed: 2,
      shortPassing: 2,
      strength: 2,
      ballControl: 2,
      defensiveAwareness: 2,
      positioning: 2,
      standingTackles: 2,
    },
    "1": {
      volleys: 1,
      defensiveAwareness: 1,
      shotPower: 1,
      standingTackles: 1,
      ballControl: 1,
      slidingTackles: 1,
      positioning: 1,
      agility: 1,
      vision: 1,
      strength: 1,
      longPassing: 1,
      shortPassing: 1,
      sprintSpeed: 1,
      curve: 1,
      penalties: 1,
      dribbling: 1,
    },
  },
  "261": {
    "3": {
      strength: 4,
      standingTackles: 4,
      slidingTackles: 4,
      defensiveAwareness: 8,
      interceptions: 8,
      jumping: 12,
      headingAccuracy: 12,
      aggression: 8,
    },
    "2": {
      strength: 2,
      jumping: 8,
      aggression: 4,
      standingTackles: 2,
      headingAccuracy: 8,
      defensiveAwareness: 4,
      slidingTackles: 2,
      interceptions: 4,
    },
    "1": {
      aggression: 2,
      defensiveAwareness: 2,
      slidingTackles: 1,
      jumping: 3,
      interceptions: 2,
      strength: 1,
      headingAccuracy: 3,
      standingTackles: 1,
    },
  },
  "268": {
    "3": {
      standingTackles: 8,
      sprintSpeed: 8,
      slidingTackles: 12,
      acceleration: 8,
      interceptions: 8,
      headingAccuracy: 4,
      defensiveAwareness: 4,
    },
    "1": {
      sprintSpeed: 2,
      slidingTackles: 3,
      interceptions: 2,
      acceleration: 2,
      standingTackles: 2,
      defensiveAwareness: 1,
      headingAccuracy: 1,
    },
    "2": {
      acceleration: 4,
      slidingTackles: 8,
      interceptions: 4,
      standingTackles: 4,
      headingAccuracy: 2,
      defensiveAwareness: 2,
      sprintSpeed: 4,
    },
  },
  "254": {
    "2": {
      strength: 4,
      finishing: 4,
      jumping: 4,
      dribbling: 4,
      penalties: 2,
      ballControl: 4,
      longShots: 4,
      reactions: 2,
      shotPower: 2,
    },
    "3": {
      ballControl: 8,
      longShots: 8,
      reactions: 4,
      penalties: 4,
      dribbling: 8,
      jumping: 8,
      shotPower: 4,
      finishing: 8,
      strength: 8,
    },
    "1": {
      jumping: 2,
      ballControl: 2,
      strength: 2,
      reactions: 1,
      longShots: 2,
      finishing: 2,
      penalties: 1,
      dribbling: 2,
      shotPower: 1,
    },
  },
  "265": {
    "3": {
      defensiveAwareness: 4,
      headingAccuracy: 4,
      jumping: 8,
      standingTackles: 8,
      interceptions: 4,
      acceleration: 4,
      aggression: 4,
      sprintSpeed: 4,
      slidingTackles: 8,
      strength: 8,
    },
    "2": {
      defensiveAwareness: 2,
      headingAccuracy: 2,
      aggression: 2,
      sprintSpeed: 2,
      interceptions: 2,
      slidingTackles: 4,
      jumping: 4,
      strength: 4,
      acceleration: 2,
      standingTackles: 4,
    },
    "1": {
      standingTackles: 2,
      aggression: 1,
      headingAccuracy: 1,
      strength: 2,
      sprintSpeed: 1,
      acceleration: 1,
      defensiveAwareness: 1,
      interceptions: 1,
      jumping: 2,
      slidingTackles: 2,
    },
  },
  "251": {
    "2": {
      longShots: 8,
      penalties: 2,
      strength: 8,
      aggression: 4,
      shotPower: 4,
      positioning: 2,
      volleys: 4,
      jumping: 2,
    },
    "3": {
      penalties: 4,
      aggression: 8,
      jumping: 4,
      strength: 12,
      shotPower: 8,
      longShots: 12,
      positioning: 4,
      volleys: 8,
    },
    "1": {
      penalties: 1,
      positioning: 1,
      jumping: 1,
      longShots: 3,
      volleys: 2,
      aggression: 2,
      strength: 4,
      shotPower: 2,
    },
  },
  "262": {
    "3": {
      dribbling: 12,
      interceptions: 4,
      balance: 8,
      standingTackles: 12,
      ballControl: 4,
      slidingTackles: 8,
      agility: 4,
      defensiveAwareness: 8,
    },
    "2": {
      dribbling: 8,
      ballControl: 2,
      defensiveAwareness: 4,
      standingTackles: 8,
      interceptions: 2,
      agility: 2,
      balance: 4,
      slidingTackles: 4,
    },
    "1": {
      dribbling: 3,
      agility: 1,
      defensiveAwareness: 2,
      ballControl: 1,
      balance: 2,
      interceptions: 1,
      slidingTackles: 2,
      standingTackles: 3,
    },
  },
  "263": {
    "3": {
      standingTackles: 8,
      finishing: 12,
      slidingTackles: 12,
      interceptions: 8,
      headingAccuracy: 4,
      shotPower: 8,
      defensiveAwareness: 8,
      volleys: 4,
    },
    "2": {
      finishing: 8,
      shotPower: 4,
      headingAccuracy: 2,
      volleys: 2,
      interceptions: 4,
      slidingTackles: 8,
      standingTackles: 4,
      defensiveAwareness: 4,
    },
    "1": {
      volleys: 1,
      interceptions: 2,
      slidingTackles: 3,
      finishing: 3,
      shotPower: 2,
      headingAccuracy: 1,
      standingTackles: 2,
      defensiveAwareness: 2,
    },
  },
  "258": {
    "3": {
      crossing: 4,
      standingTackles: 12,
      defensiveAwareness: 4,
      shortPassing: 8,
      interceptions: 8,
      longPassing: 8,
      vision: 12,
      curve: 4,
    },
    "2": {
      standingTackles: 8,
      interceptions: 4,
      longPassing: 4,
      curve: 2,
      vision: 8,
      crossing: 2,
      defensiveAwareness: 2,
      shortPassing: 4,
    },
    "1": {
      shortPassing: 2,
      crossing: 1,
      defensiveAwareness: 1,
      interceptions: 2,
      vision: 3,
      longPassing: 2,
      standingTackles: 3,
      curve: 1,
    },
  },
  "260": {
    "3": {
      acceleration: 4,
      shortPassing: 4,
      curve: 8,
      balance: 8,
      agility: 4,
      crossing: 8,
      sprintSpeed: 4,
      dribbling: 8,
      longPassing: 4,
      vision: 4,
    },
    "1": {
      longPassing: 1,
      shortPassing: 1,
      crossing: 2,
      curve: 2,
      agility: 1,
      dribbling: 2,
      balance: 2,
      acceleration: 1,
      sprintSpeed: 1,
      vision: 1,
    },
    "2": {
      dribbling: 4,
      acceleration: 2,
      crossing: 4,
      longPassing: 2,
      agility: 2,
      vision: 2,
      shortPassing: 2,
      curve: 4,
      sprintSpeed: 2,
      balance: 4,
    },
  },
  "264": {
    "3": {
      longPassing: 8,
      standingTackles: 8,
      interceptions: 8,
      aggression: 8,
      defensiveAwareness: 4,
      jumping: 8,
      slidingTackles: 4,
      strength: 4,
      vision: 8,
    },
    "2": {
      standingTackles: 4,
      longPassing: 4,
      strength: 2,
      aggression: 4,
      slidingTackles: 2,
      vision: 4,
      defensiveAwareness: 2,
      interceptions: 4,
      jumping: 4,
    },
    "1": {
      defensiveAwareness: 1,
      slidingTackles: 1,
      aggression: 2,
      longPassing: 2,
      standingTackles: 2,
      interceptions: 2,
      jumping: 2,
      vision: 2,
      strength: 1,
    },
  },
  "267": {
    "3": {
      crossing: 12,
      shortPassing: 4,
      acceleration: 8,
      curve: 4,
      sprintSpeed: 8,
      freeKickAccuracy: 8,
      longPassing: 8,
    },
    "2": {
      curve: 2,
      longPassing: 4,
      crossing: 8,
      shortPassing: 2,
      freeKickAccuracy: 4,
      acceleration: 4,
      sprintSpeed: 4,
    },
    "1": {
      sprintSpeed: 2,
      crossing: 3,
      acceleration: 2,
      freeKickAccuracy: 2,
      curve: 1,
      longPassing: 2,
      shortPassing: 1,
    },
  },
  "269": {
    "3": { gkDiving: 12, gkHandling: 4, gkKicking: 8 },
    "2": { gkDiving: 8, gkKicking: 4, gkHandling: 2 },
    "1": { gkKicking: 2, gkDiving: 3, gkHandling: 1 },
  },
  "270": {
    "3": { gkKicking: 8, sprintSpeed: 3, gkReflexes: 12 },
    "2": { gkReflexes: 8, sprintSpeed: 2, gkKicking: 4 },
    "1": { gkKicking: 2, gkReflexes: 3, sprintSpeed: 1 },
  },
  "273": {
    "3": {
      gkKicking: 4,
      gkDiving: 4,
      gkPositioning: 4,
      sprintSpeed: 4,
      acceleration: 4,
      gkHandling: 4,
      gkReflexes: 4,
    },
    "2": {
      sprintSpeed: 2,
      gkKicking: 2,
      acceleration: 2,
      gkPositioning: 2,
      gkDiving: 2,
      gkReflexes: 2,
      gkHandling: 2,
    },
    "1": {
      acceleration: 1,
      gkReflexes: 1,
      gkDiving: 1,
      gkKicking: 1,
      gkPositioning: 1,
      sprintSpeed: 1,
      gkHandling: 1,
    },
  },
  "272": {
    "3": { gkHandling: 12, gkPositioning: 4, gkDiving: 8 },
    "2": { gkDiving: 4, gkHandling: 8, gkPositioning: 2 },
    "1": { gkDiving: 2, gkHandling: 3, gkPositioning: 1 },
  },
  "271": {
    "1": { gkReflexes: 2, acceleration: 1, gkPositioning: 3 },
    "3": { gkReflexes: 8, acceleration: 4, gkPositioning: 12 },
    "2": { gkReflexes: 4, acceleration: 2, gkPositioning: 8 },
  },
};

export type AllStatsBonus = number[];
export type SpecificStatsBonus = {
  [key: string]: number;
};

export type CalculatePlayerStatsBonus = {
  allStatsBonus: AllStatsBonus;
  specificStatsBonus: SpecificStatsBonus;
};

export const calculatePlayerStatsBonus = (
  chemStyle: number,
  chemistry: number,
  inGameAttributes: { [label: string]: number },
  faceCardStats: number[],
) => {
  // No chemistry means no stat bonuses
  if (chemistry === 0 || chemStyle === undefined) {
    return {
      allStatsBonus: [],
      specificStatsBonus: {},
    };
  }

  // Get the stat bonuses for this specific chemstyle and chemistry level
  const chemstyleStatBonusForSpecificStyle =
    chemstyleStatBonus["" + chemStyle]["" + chemistry];

  // Calculate bonuses for each of the 6 main stats
  let allStatsBonus: number[] = [];

  // Use player or keeper attribute weights based on chemstyle
  const attributeWeights =
    chemStyle < 269 ? playerAttrWeights : keeperAttrWeights;

  Object.values(attributeWeights).forEach((attr, index) => {
    let weightedStats = [];

    Object.entries(attr).forEach(([key, weight]) => {
      // Calculate: (chemstyle bonus + base stat) * weight
      weightedStats.push(
        Math.min(
          99,
          (chemstyleStatBonusForSpecificStyle?.[key] || 0) +
            inGameAttributes[key],
        ) * +weight,
      );
    });

    // Sum weighted stats and subtract original face stat to get bonus
    allStatsBonus.push(
      Math.round(
        weightedStats.reduce((a, b) => a + b, 0) - faceCardStats[index],
      ),
    );
  });

  return {
    allStatsBonus,
    specificStatsBonus: chemstyleStatBonusForSpecificStyle,
  };
};
